import { z } from '../../../zod';
import { StripeAmountValidationSchema } from '../../../shared/stripeAmount';

export const PageCoverProcessingFeesValidationSchema = z
  .object({
    enabled: z.boolean().nullish().openapi({
      description: 'Offer customers a checkbox at checkout to cover the processing fee.',
      example: true,
    }),
    percentage: z.number().min(0).max(100).nullish().openapi({
      description:
        'Percentage of everything the customer pays, tax included. Added to `amount` to make the contribution.',
      example: 2.9,
    }),
    amount: StripeAmountValidationSchema.int().nullish().openapi({
      description: 'Fixed part of the contribution in the page currency minor unit (e.g. cents).',
      example: 30,
    }),
    label: z.string().max(200).nullish().openapi({
      description: 'Text next to the checkbox. Defaults to "Help cover processing fees".',
      example: 'Help cover processing fees',
    }),
    showAmount: z.boolean().nullish().openapi({
      description: 'Show the contribution in brackets after the label. Defaults to true.',
      example: true,
    }),
    preselected: z.boolean().nullish().openapi({
      description: 'Tick the checkbox for the customer when the checkout loads. Defaults to false.',
      example: false,
    }),
  })
  .meta({
    id: 'PageCoverProcessingFees',
    description:
      'An option that lets customers choose to cover the processing fee. The contribution is `percentage` of the total plus `amount`, and is not an Additional fee.',
  });

const COVER_PROCESSING_FEES_LIST_DESCRIPTION =
  'Options that let customers choose to cover the processing fee. The list holds at most one option for now. Sending it replaces the whole list.';

export const PageCoverProcessingFeesInputValidationSchema = z
  .array(PageCoverProcessingFeesValidationSchema)
  .max(1)
  .nullish()
  .meta({ description: COVER_PROCESSING_FEES_LIST_DESCRIPTION });

export const PageCoverProcessingFeesResponseValidationSchema = z
  .array(PageCoverProcessingFeesValidationSchema)
  .nullish()
  .meta({
    description:
      'Options that let customers choose to cover the processing fee. Empty when the page has none. The list holds at most one option for now.',
  });
